import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'
import { useDispatch, useSelector } from 'react-redux'
import { editSupplyBillsItemsFiltersAgreeHeader } from '../../../../../store/supplyBillSlice'

const SupplyBillItemsAllFilterAgreeHeader = () => {

	const agree = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeHeader)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(agree)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'yes',
			name: 'Так'
		},
		{
			id: 'no',
			name: 'Ні'
		},
		{
			id: 'other',
			name: 'Немає'
		},
		{
			id: 'all',
			name: 'Всі'
		},
	])

  return (
    <MySelect
        value={value}
        label="Погодження керівником"
        labelId="select__filterAgreeHeader-label"
        id='select__filterAgreeHeader'
        onChange = {e => {
            setValue(e)
			dispatch(editSupplyBillsItemsFiltersAgreeHeader(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Погодження керівником'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyBillItemsAllFilterAgreeHeader